import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserService } from './users.service';
import { ElectricityService } from './electricity.service';
import { StateService } from './state.service';
import { SmartTableService } from './smart-table.service';
import { PlayerService } from './player.service';
import { UserActivityService } from './user-activity.service';
import { OrdersChartService } from './orders-chart.service';
import { ProfitChartService } from './profit-chart.service';
import { TrafficListService } from './traffic-list.service';
import { PeriodsService } from './periods.service';
import { EarningService } from './earning.service';
import { OrdersProfitChartService } from './orders-profit-chart.service';
import { TrafficBarService } from './traffic-bar.service';
import { ProfitBarAnimationChartService } from './profit-bar-animation-chart.service';
import { LayoutService } from './layout.service';


// Service rest
import {ApiEndpoints} from './rest/ApiEndpoints';
import {ApiUtils} from './rest/ApiUtils';
import {ProduitService} from './rest/produit/produit-service';
import {PartenaireService} from './rest/partenaire/partenaire-service';
import {FactureService} from './rest/facture/facture-service';
import {FluxStockService} from './rest/fluxstock/fluxstock-service';
import {FluxService} from './rest/flux/flux-service';
import {ReglementService} from './rest/reglement/reglement-service';
import {CompteService} from './rest/compte/compte-service';
import {UserApiService} from './rest/user/user-service';
import {BordereauService} from './rest/bordereau/bordereau-service';

import {PlanTarifaireService} from './rest/plantarifaire/plantarifaire-service';

import {PermissionService} from './rest/permission/permissions-service';

import {CompanyService} from './rest/company/company-service';

import {InventaireService} from './rest/inventaire/inventaire-service';

import {SettingService} from './rest/setting-service';

import {CashSessionService} from './rest/caisse/cashsession-service';
import { CatProduitService } from './rest/catproduit/catproduit-service';

import {DashboardService} from './rest/dashboard/dashboard-service';
import { TaxeService } from './rest/taxe/taxe-service';
import { DeviceService } from './rest/device/device-service';
import { CategoryService } from './rest/category/category-service';
import { ArticleService } from './rest/article/article-service';
import { PublicationService } from './rest/publication/publication-service';
import { EventSendeurService } from './event-sendeur.service';
import { MenuService } from './rest/menu/menu-service';
import { AvisProduitService } from './rest/avisproduit/avisproduit-service';
import { CommentService } from './rest/comment/comment-service';
import { PaiementService } from './rest/paiement/paiement-service';
import { ApiSettingService } from './rest/apisetting/apisetting-service';


const SERVICES = [
  UserService,
  UserApiService,
  ElectricityService,
  StateService,
  SmartTableService,
  PlayerService,
  UserActivityService,
  OrdersChartService,
  ProfitChartService,
  TrafficListService,
  PeriodsService,
  EarningService,
  OrdersProfitChartService,
  TrafficBarService,
  ProfitBarAnimationChartService,
  LayoutService,
  ApiEndpoints,
  ApiUtils,
  ProduitService,
  CatProduitService,
  PartenaireService,
  FactureService,
  FluxStockService,
  ReglementService,
  SettingService,
  FluxService,
  CompteService,
  PlanTarifaireService,
  PermissionService,
  CompanyService,
  InventaireService,
  CashSessionService,
  BordereauService,
  DashboardService,
  TaxeService,
  DeviceService,
  CategoryService,
  ArticleService,
  PublicationService,
  EventSendeurService,
  MenuService,
  AvisProduitService,
  CommentService,
  PaiementService,
  ApiSettingService,
  // AsyncPipe
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class DataModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: DataModule,
      providers: [
        ...SERVICES,
      ],
    };
  }
}
